module.exports = __webpack_public_path__ + "static/img/hd.3e4cb94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hd.png
// module id = kDH3
// module chunks = 1